export default "__VITE_ASSET__94f0b1c4__"